import { FC } from 'react';
import { PageTitle, PageLink } from '../../../_metronic/layout/core';
import { View } from './components/View';
import { useParams } from 'react-router-dom';
import { decryptId } from '../../../_metronic/helpers';

const NoteSupplierPage: FC = () => {
  const { proveedor_id, id } =
    useParams<{ proveedor_id: string; id: string }>();

  const noteId = decryptId(id);
  const breadCrumbs: Array<PageLink> = [
    {
      title: 'Proveedores',
      path: '/cotizaciones/proveedores/',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
    {
      title: 'Editar',
      path: `/cotizaciones/proveedores/edit/${proveedor_id}`,
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
    {
      title: 'Notas',
      path: `/cotizaciones/proveedores/edit/${proveedor_id}`,
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ];
  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>
        {noteId ? 'Editar nota' : 'Nueva nota'}
      </PageTitle>

      <View id={noteId ? noteId : '0'} />
    </>
  );
};

export { NoteSupplierPage };
